<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd"
         style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4"
                class="search-nav-left">
          <i class="el-icon-search"
             style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20"
                class="search-nav-right">
          <el-button class="search-open-close"
                     type="text"
                     @click="hide=!hide"
                     v-show="hide">收起查询</el-button>
          <el-button class="search-open-close"
                     type="text"
                     @click="hide=!hide"
                     v-show="!hide">展开查询</el-button>
          <i v-if="hide === true"
             class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false"
             class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new"
                     type="primary"
                     size="small"
                     @click="searchLoad">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide"
             class="search-content common-search-formtype">
          <el-form :inline="true"
                   :model="formInlineTmp"
                   label-width="95px"
                   class="search-content-item">
            <el-form-item label="活动名称:">
              <el-input v-model.trim="formInlineTmp.name"
                        placeholder="请输入活动名称"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="开始时间:">
              <el-date-picker style="width:193px;"
                              class="time-picker"
                              v-model="formInlineTmp.start_time"
                              type="datetime"
                              placeholder="开始时间"
                              value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间:">
              <el-date-picker style="width:190px;"
                              class="time-picker"
                              v-model="formInlineTmp.end_time"
                              type="datetime"
                              placeholder="结束时间"
                              value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="活动状态:">
              <el-select v-model="formInlineTmp.status"
                         placeholder="请选择">
                <el-option v-for="item in statusOptions"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top"
            style="padding-right:0">
      <el-col :span="4"
              style="text-align: left;">
        <i class="el-icon-document"
           style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20"
              class="text-align-right">
        <el-button type="primary"
                   @click="pushToPage"
                   class="add-btn btn-right"
                   style="float: right;">添加</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table :data="tableData"
                v-loading="loading"
                class="table">
        <el-table-column label="ID">
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column>
        <el-table-column label="活动名称">
          <template slot-scope="scope">
            <div class="op-link"
                 @click="pushToDetailPage(scope.row.id)">
              {{ scope.row.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column width='120'
                         label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 0">兑换券</span>
            <span v-if="scope.row.type === 1">代金券</span>
          </template>
        </el-table-column>
        <el-table-column width='120'
                         label="投放数量">
          <template slot-scope="scope">
            {{ scope.row.put_number }}
          </template>
        </el-table-column>
        <el-table-column width='120'
                         label="领取数量">
          <template slot-scope="scope">
            {{ scope.row.receive_number }}
          </template>
        </el-table-column>
        <el-table-column width='120'
                         label="使用数量">
          <template slot-scope="scope">
            {{ scope.row.use_number }}
          </template>
        </el-table-column>
        <el-table-column width='100'
                         prop="status"
                         label="状态">
          <template slot-scope="scope">
            {{ scope.row.statusStr}}
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         width="300">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 1"
                 class="op-link"
                 @click="stopCoupons(scope.row.id)">
              下线
            </div>
            <div v-if="scope.row.status === 0"
                 class="op-link"
                 @click="enableCoupons(scope.row.id)">
              发布
            </div>
            <div v-if="scope.row.status === 1"
                 class="op-link"
                 @click="showAddNumdialog(scope.row.id,scope.row.put_number)">
              追加
            </div>
            <div v-if="scope.row.status === 0"
                 class="op-link">
              <router-link :to="{ name: 'editCoupons', query: { id: scope.row.id }}">
                编辑
              </router-link>
            </div>
            <div class="op-link"
                 v-if="scope.row.status === 1">
              <router-link :to="{ name: 'couponsStatistics', query: { id: scope.row.id }}">
                统计
              </router-link>
            </div>
            <div class="op-link"
                 v-if="scope.row.status === 1"
                 @click="downCoupons(scope.row.id)">
              下载
            </div>
            <div class="op-link"
                 v-if="scope.row.status === 1"
                 @click="qrcodeDownCoupons(scope.row.id)">
              二维码下载
            </div>
            <div class="op-link"
                 v-if="scope.row.status === 0 || scope.row.status === 3"
                 @click="deleteAction(scope.row.id)">
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination"
                       background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :page-size="limit"
                       layout="total, prev, pager, next, jumper"
                       :total="totalCount">
        </el-pagination>
      </div>
      <!--追加弹窗-->
      <el-dialog class="cellDialog base-dialog"
                 title="追加券投放数量"
                 :visible.sync="addNumdialog"
                 width="600px">
        <el-form ref="addForm"
                 :model="addForm"
                 style="text-align: left;">
          <el-form-item label="当前已投放数量:"
                        :label-width="addLabelWidth"
                        prop="oldnumber">
            <span>{{ currentNum }}张</span>
          </el-form-item>
          <el-form-item label="追加投放数:"
                        :label-width="addLabelWidth"
                        prop="put_number"
                        :rules="[
            { required: true, message: '不能为空'}
            ]">
            <el-input type="number"
                      v-model="addForm.put_number"
                      auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer"
             style="margin-top: 10px">
          <el-button class="dialog-cancel-btn"
                     @click="addNumdialog = false"
                     style="margin-left: 20px">取 消</el-button>
          <el-button class="dialog-confirm-btn"
                     style="margin-right: 32px"
                     type="primary"
                     @click="submitForm('addForm')">确 定</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>
<script>
import { getCoupons, enableCoupons, stopCoupons, deleteCoupons, addCouponNumber, downloadCoupons, qrcodeDownload } from '@/api/yunzhong.js'
export default {
  name: 'list',
  data () {
    return {
      loading: true,
      statusOptions: [{
        label: '全部',
        value: ''
      },
      {
        label: '已发布',
        value: '1'
      },
      {
        label: '未发布',
        value: '2'
      },
      {
        label: '已过期',
        value: '3'
      }],
      hide: true,
      tableData: [],
      page: 1,
      totalCount: 0,
      formInlineTmp: {},
      formInline: {},
      limit: 10,
      addNumdialog: false,
      currentId: 0,
      addLabelWidth: '120px',
      currentNum: 0,//追加-当前已投放张数
      addForm: {
        put_number: 0
      }
    }
  },
  methods: {
    searchLoad () {
      this.page = 1
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.getData()
    },
    pushToDetailPage (id) {
      router.push({ name: 'couponsDetail', query: { id: id } })
    },
    // 显示追加弹窗
    showAddNumdialog (id, num) {
      this.addNumdialog = true
      this.currentNum = num
      this.currentId = id
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAdd()
        } else {
          return false
        }
      })
    },
    // 追加弹窗 确定
    confirmAdd () {
      addCouponNumber(this.currentId, this.addForm.put_number).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '追加投放量成功')
          this.addNumdialog = false
          this.addForm.put_number = 0
          this.getData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    pushToPage () {
      router.push('/home/add-coupons')
    },
    // 下线
    stopCoupons (id) {
      this.$confirm('确认要下线该优惠券?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        stopCoupons(id).then((res) => {
          if (res.data.code === 0) {
            this.getData()
            _g.toastMsg('success', res.data.error)
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 发布
    enableCoupons (id) {
      this.$confirm('确认要发布该优惠券?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        enableCoupons(id).then(res => {
          if (res.data.code === 0) {
            this.getData()
            _g.toastMsg('success', res.data.error)
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 删除
    deleteAction (id) {
      this.$confirm('确认删除该优惠券?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCoupons(id).then((res) => {
          if (res.data.code === 0) {
            this.getData()
            _g.toastMsg('success', '删除成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    downCoupons (id) {
      downloadCoupons(id).then((res) => {
        //console.log(res)
        this.download(res)
      })
    },
    qrcodeDownCoupons (id) {
      // _g.toastMsg('success', '请稍等...')
      this.loading = true
      qrcodeDownload(id).then((res) => {
        //console.log(res.data.error)
        //this.zipdownload(res)
        this.loading = false
        if (res.data.code === 0) {
          window.location.href = res.data.data
        }
        else {
          _g.toastMsg('error', res.data.error)
        }
      })
      // this.openLoading()
    },
    // 下载文件
    download (z) {
      if (!data) {
        _g.toastMsg('error', '没有数据')
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/plain;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.txt' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 下载文件
    zipdownload (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/zip;charset=utf-8' })
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.zip' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 处理分页
    handleSizeChange (val) {
      this.limit = val
    },
    handleCurrentChange (page) {
      console.log('handleCurrentChangethis.formInline', this.formInline)
      this.page = page
      this.getData()
    },
    getData () {
      this.loading = true
      getCoupons(this.page, this.formInline).then(res => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.count
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  created () {
    this.getData()
  },
  components: {}
}

</script>
<style scoped>
.sign-manage-title {
  height: 40px;
}

.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}

.content-one p {
  text-align: left;
}
</style>
